import { ViewType } from "@ms/uno-constants/lib/local/RoutingConstants";
/** Every Gantt-based view that persists a zoom preference, for exhaustive iteration. */ export const GanttZoomViewTypes = [
    ViewType.Timeline,
    ViewType.People
];
